export const enum EventListQuery {
	FILTERS = 'filters',
	TOPIC = 'topic',
	TYPE = 'type',
}
